






























































































































































































































































import { watch } from '@vue/composition-api';
import { LoaderCircle, Scrollbar } from '@/app/components';
import { useAxios, useFilters } from '@/app/composable';
import store from '@/app/store';
import { AccessLevel } from '@/modules/access-policy/constants/access-levels.constants';
//import { AssetsAPI } from '@/modules/asset/api';
//import { useAsset } from '@/modules/asset/composable/asset';
import { useAssetExtentMetadata } from '@/modules/asset/composable/asset-extent-metadata';
//import { useWishList } from '@/modules/asset/composable/wish-list';
import { AssetTypeId } from '@/modules/asset/constants';
import { Asset } from '@/modules/asset/types';
import { PropType, computed, defineComponent, ref } from '@vue/composition-api';
//import { TrinityRingsSpinner } from 'epic-spinners';
import { ContractsAPI } from '../../api';
import { useCart } from '../../composable';

export default defineComponent({
    name: 'AssetDetails',
    components: {
        LoaderCircle,
        Scrollbar,
    },
    props: {
        asset: {
            type: Object as PropType<Asset>,
            default: null,
        },
        showTabs: {
            type: Boolean,
            default: true,
        },
        activePendingContracts: {
            type: Array,
            default: () => [],
        },
    },
    setup(props, { root, emit }) {
        const { exec, loading } = useAxios(true);

        const { formatLargeNumber, formatDate, capitalise } = useFilters();
        //const { assetTypeClass, assetTypeName } = useAsset();

        //const { cartAssetIds, addToCart, removeFromCart, cart, cartLimit } = useCart();
        const { cartAssetIds, addToCart, removeFromCart } = useCart();
        // const {
        //     wishListBtnName,
        //     isInWishList,
        //     viewedAsset,
        //     loading: changeWishListState,
        //     toggleWishListState,
        //     removeAssetFromWishList,
        //     fetchWishListAssetIds,
        // } = useWishList(root);

        const isBlockchainEnabled = computed(() => store.getters.sharing.isBlockchainEnabled);
        const user = computed(() => store.state.auth.user);
        const ethNetwork = computed(() => store.state.sharing.network);
        const hasWallet = computed(() => store.getters.organisation.hasWallet);
        const isAssetPublic = computed(() => props.asset && props.asset.accessLevel === AccessLevel.Public);
        const isDataset = computed(() => props.asset?.assetTypeId === AssetTypeId.Dataset);
        const cartLimitReached = computed(() => {
            return false;
            //return cart.value.length >= cartLimit
        });

        const activePendingContract = computed(() => {
            if (props.asset) {
                const contract: any = props.activePendingContracts.find(
                    (item: any) => item.assetId === props.asset.id || item.barteringAssetId === props.asset.id,
                );
                return contract ?? null;
            }
            return null;
        });

        const belongsToUserOrOrganisation = computed(() => {
            if (props.asset && user.value) {
                if (user.value.organisationId && props.asset.organisation)
                    return user.value.organisationId === props.asset.organisation.id;
                return user.value.id === props.asset.createdBy.id;
            }
            return true;
        });

        const hasOrganisation = ref<boolean>(!!user.value.organisationId);
        const acquiringAsset = ref<boolean>(false);
        const activeAssetTab = ref<string>('overview');
        const temporalCoverage = ref<string | null>(null);
        const spatialCoverage = ref<string | null>(null);
        const inputAssets = ref<any>([]);

        const acquireAsset = (id: number) => {
            acquiringAsset.value = true;
            const payload = {
                isBundle: false,
                contracts: [{ fields: [], duration: { type: 'forever', number: null }, assetId: id }],
            };
            exec(ContractsAPI.create(payload))
                .then(() => {
                    props.activePendingContracts.push(id);
                    acquiringAsset.value = false;
                    (root as any).$toastr.s('Asset acquired!', 'Success');

                    // if (isInWishList.value) {
                    //     removeAssetFromWishList(id);
                    // }
                    emit('reload-active-pending');
                })
                .catch(() => {
                    acquiringAsset.value = false;
                    (root as any).$toastr.e('Asset acquisition failed.', 'Error');
                });
        };

        const buyAsset = (id: number) => {
            root.$router.push({ name: 'contract-details', params: { type: 'create', id: `${id}` } });
        };

        const changeAssetTab = (tab?: string) => {
            if (tab) activeAssetTab.value = tab;
        };

        // const fetchInputAssets = () => {
        //     exec(AssetsAPI.getInputAssets(props.asset.id)).then((res: any) => {
        //         inputAssets.value = res.data?.inputAssets;
        //     });
        // };
        const viewedAsset = ref();

        watch(
            () => props.asset,
            () => {
                viewedAsset.value = props.asset;
                const { spatialCoverage: sc, temporalCoverage: tc } = useAssetExtentMetadata(viewedAsset);
                spatialCoverage.value = sc.value;
                temporalCoverage.value = tc.value;
            },
        );

        return {
            formatDate,
            formatLargeNumber,
            buyAsset,
            acquireAsset,
            ethNetwork,
            hasWallet,
            belongsToUserOrOrganisation,
            hasOrganisation,
            isBlockchainEnabled,
            temporalCoverage,
            spatialCoverage,
            addToCart,
            removeFromCart,
            cartAssetIds,
            // assetTypeClass,
            // assetTypeName,
            acquiringAsset,
            // changeWishListState,
            // toggleWishListState,
            // wishListBtnName,
            activeAssetTab,
            loading,
            changeAssetTab,
            capitalise,
            isAssetPublic,
            activePendingContract,
            cartLimitReached,
            //isInWishList,
            inputAssets,
            AssetTypeId,
            isDataset,
        };
    },
});
